import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const pickupInspectionAvailabilityEnum = createEnum({
    PICKABLE: ['pickable', '可提', 'success'],
    NOT_PICKABLE: ['not_pickable', '不可提', 'error'],
});
export const PICKUP_INSPECTION_AVAILABILITIES = enumValues(pickupInspectionAvailabilityEnum);
export const PICKUP_INSPECTION_AVAILABILITY_LABEL_MAP = enumLabelMap(pickupInspectionAvailabilityEnum);
export const pickupInspectionAppearanceEnum = createEnum({
    INTACT: ['intact', '完好', 'success'],
    FLAWED: ['flawed', '有瑕疵', 'warning'],
});
export const PICKUP_INSPECTION_APPEARANCES = enumValues(pickupInspectionAppearanceEnum);
export const PICKUP_INSPECTION_APPEARANCE_LABEL_MAP = enumLabelMap(pickupInspectionAppearanceEnum);
export const pickupInspectionAccessoryEnum = createEnum({
    CERTIFICATE: ['certificate', '合格证'],
    ENVIRONMENTAL_LIST: ['environmental_list', '环保清单'],
    WARNING_TRIANGLE: ['warning_triangle', '三脚架'],
    WARNING_VEST: ['warning_vest', '警示背心'],
    FIRE_EXTINGUISHER: ['fire_extinguisher', '灭火器'],
    CHARGING_GUN: ['charging_gun', '充电枪'],
});
export const PICKUP_INSPECTION_ACCESSORIES = enumValues(pickupInspectionAccessoryEnum);
export const PICKUP_INSPECTION_ACCESSORY_LABEL_MAP = enumLabelMap(pickupInspectionAccessoryEnum);
//# sourceMappingURL=pickup-inspection.js.map